import { IOdataFilter } from './IOdataFilter';
import { IOdataField } from '../Field/IOdataField';

export class OdataFilterSubstringOf implements IOdataFilter {
  private field1: IOdataField;
  private field2: IOdataField;

  constructor(field: IOdataField, substringValue: IOdataField) {
    this.field1 = field;
    this.field2 = substringValue;
  }

  toFilterString() {
    return `contains(${this.field1.toFieldString()},${this.field2.toFieldString()})`;
  }
}
